<template>
    <v-progress-linear v-if="loading"/>
    <div class="px-2" v-else>
        <v-subheader class="pl-0">Siste push-meldinger</v-subheader>
        <v-card class="py-1 blue lighten-5 elevation-0 mb-1" v-for="msg in log" :key="msg.id">
            <p class="mx-2 my-0 pt-1">
                <strong>{{ msg.notification.title }}</strong> <br>
                {{ msg.notification.message }}
            </p>
            <small class="ma-2 blue--text">{{ dayjs(msg.datetime).format('DD.MM.YYYY HH:mm') }}</small>
        </v-card>
        <em v-if="log.length === 0">Ingen meldinger sendt.</em>
    </div>
</template>

<script>
    import dayjs from 'dayjs';
    import axios from 'axios';

    export default {
        created() {
            this.loading = true;
            this.loadData().finally(() => {
                this.loading = false;
            });

            setInterval(() => {
                this.loadData()
            }, 15000);
        },

        data() {
            return {
                loading: false,
                log: []
            }
        },

        methods: {
            dayjs,
            loadData() {
                return axios.get('/api/notifications/logs/').then(response => {
                    this.log = response.data;
                })
            }
        }
    }
</script>